// El pool del selector de «Empezar una tarea»: lo que hay en Mis tareas, aplanado y listo para
// elegir. Puro, sin React ni red.

// Una tarea de Mis tareas -> la seleccion que entiende el cronometro, o null si no se puede
// enlazar (una pagina de Notion sin id externo, una tarea que ya no existe).
export function aSeleccion(t) {
  if (!t || t.no_disponible) return null;
  // Un encargo que me han mandado: tarea suelta, se enlaza con su fila de Mis tareas (origen "suelta").
  if (t.origen === "encargo") {
    if (t.id == null) return null;
    return { kind: "suelta", id: String(t.id), title: t.titulo,
             sub: t.enviada_por?.nombre ? `Enviada por ${t.enviada_por.nombre}` : "Tarea enviada", mt_id: String(t.id) };
  }
  if (t.origen === "notion") {
    if (!t.external_id) return null;
    return { kind: "notion", id: String(t.external_id), parent: t.parent_external_id ? String(t.parent_external_id) : null,
             title: t.titulo, sub: t.proyecto?.nombre || "Notion", mt_id: t.id ?? null };
  }
  if (t.task_id == null) return null;
  return { kind: "paso", id: String(t.task_id), project_id: t.proyecto?.id != null ? String(t.proyecto.id) : null,
           title: t.titulo, sub: t.proyecto?.nombre || "Sin proyecto", mt_id: t.id ?? null };
}

const cuando = t => {
  const p = t.plan;
  if (p?.tipo === "hoy") return "Hoy";
  if (p?.tipo === "semana") return "Esta semana";
  if (p?.tipo === "semana_siguiente") return "Semana que viene";
  return null;
};

// Aplana la respuesta de GET /api/mis-tareas: lo planificado primero (hoy, dias, semana) y
// despues lo demas; sin duplicados y sin las aplazadas.
export function aplanarMisTareas(d) {
  if (!d) return [];
  const grupos = d.plan
    ? [d.plan.hoy, ...(d.plan.dias || []), d.plan.semana, d.plan.sin_planificar]
    : [{ items: d.mi_dia || [] }, d.grupos?.vencidas, d.grupos?.hoy, d.grupos?.semana, d.grupos?.mas_adelante, d.grupos?.sin_fecha];
  const vistos = new Set();
  const salida = [];
  for (const g of grupos) {
    for (const t of g?.items || []) {
      const s = aSeleccion(t);
      if (!s) continue;
      const clave = `${s.kind}:${s.id}`;
      if (vistos.has(clave)) continue;
      vistos.add(clave);
      salida.push({ ...s, cuando: cuando(t) });
    }
  }
  return salida;
}

// Lo que se puede buscar «en todas» y todavia no esta en Mis tareas: los pasos visibles y las
// paginas de Notion enlazadas.
export function candidatasFuera({ pool, misPasos = [], notionItems = [], q = "", limite = 12 }) {
  const dentro = new Set(pool.map(s => `${s.kind}:${s.id}`));
  const t = String(q || "").trim().toLowerCase();
  const coincide = (...campos) => !t || campos.some(c => String(c || "").toLowerCase().includes(t));
  const pasos = misPasos
    .filter(p => !dentro.has(`paso:${p.id}`) && coincide(p.title, p.project_name))
    .map(p => ({ kind: "paso", id: String(p.id), project_id: String(p.project_id), title: p.title,
                 sub: p.project_name || "Proyecto", fuera: true }));
  const paginas = notionItems
    .filter(i => i.item_type !== "database" && !dentro.has(`notion:${i.external_id}`) && coincide(i.title))
    .map(i => ({ kind: "notion", id: String(i.external_id), parent: i.parent_external_id ? String(i.parent_external_id) : null,
                 title: i.title, sub: "Notion", fuera: true }));
  return [...pasos, ...paginas].slice(0, limite);
}

// Los de Mis tareas que coinciden con lo escrito.
export function filtrarPool(pool, q) {
  const t = String(q || "").trim().toLowerCase();
  if (!t) return pool;
  return pool.filter(s => String(s.title || "").toLowerCase().includes(t) || String(s.sub || "").toLowerCase().includes(t));
}
